module.exports = __webpack_public_path__ + "static/seniors-4001151a51f03e9d8f75e2feb235592d.jpeg";